import { useContext } from "react";
import { AppContext } from "../App";

export const useAppContext = () => {
  const context = useContext(AppContext);
  return context;
};
